export default function initInstagramFeedBlock() {
    const blocks = document.querySelectorAll(".instagram-feed-block");

    blocks.forEach((block) => {
        // Clone marquee items so the animation loops seamlessly
        // Reels (tab 2) get 3 copies since there are fewer items
        const marqueeInners = block.querySelectorAll(".marquee-inner");
        marqueeInners.forEach((inner) => {
            if (inner.dataset.cloned) return;
            inner.dataset.cloned = "true";
            const isReels = inner.closest(".instagram-feed__tab[data-tab='2']");
            const cloneCount = isReels ? 3 : 1;
            const items = Array.from(inner.querySelectorAll(".item"));
            for (let i = 0; i < cloneCount; i++) {
                items.forEach((item) => {
                    const clone = item.cloneNode(true);
                    clone.setAttribute("aria-hidden", "true");
                    inner.appendChild(clone);
                });
            }
        });

        const buttons = block.querySelectorAll(".instagram-tabs__button");
        const tabs = block.querySelectorAll(".instagram-feed__tab");

        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                const tabId = button.getAttribute("data-tab");

                // Remove active class from all buttons and tabs in this block
                buttons.forEach((btn) => btn.classList.remove("active"));
                tabs.forEach((tab) => tab.classList.remove("active"));

                // Add active class to clicked button and corresponding tab
                button.classList.add("active");
                const targetTab = block.querySelector(`.instagram-feed__tab[data-tab="${tabId}"]`);
                if (targetTab) {
                    targetTab.classList.add("active");
                }

                // Update aria-hidden
                tabs.forEach((tab) => {
                    if (tab.classList.contains("active")) {
                        tab.setAttribute("aria-hidden", "false");
                    } else {
                        tab.setAttribute("aria-hidden", "true");
                    }
                });
            });
        });
    });
}
